export enum CandidateStage {
  FirstContact = '1st contact',
  FirstTechnicalInterview = '1st technical interview',
  SecondTechnicalInterview = '2nd technical interview',
  TestDome = 'Test dome',
  ClientInterview = 'Client interview',
  MakeAnOffer = 'Make an offer',
}
